import { Observable } from "rxjs"

const BASE64_URL = (base64Url: string) => `data:image/jpeg;base64,${base64Url}`

export function blobToBase64(blob: Blob | null): Observable<string | null> {
    return new Observable(observer => {
        if (!blob) {
            observer.next(null)

            observer.complete()

            return
        }

        const reader = new FileReader()

        reader.onload = () => {
            observer.next(reader.result as string)

            observer.complete()
        }

        reader.onerror = (err) => observer.error(err)

        reader.readAsDataURL(blob)
    })
}

export function base64ToUrl(base64: string): string | null {
    if (!isBase64(base64)) return null

    return BASE64_URL(base64)
}

export function isBase64(img: string): boolean {
    try {
        return btoa(atob(img)) === img
    } catch (err) {
        return false
    }
}

export function base64ToFile(base64: string | null, fileName: string = 'fileName'): File | null {
    if (!base64) return null

    // Separar la cabecera del Base64
    const arr = base64.split(',')

    const mimeMatch = arr[0].match(/:(.*?);/)

    if (!mimeMatch) return null

    const mime = mimeMatch[1]

    // Decodificar Base64 a bytes
    const bstr = atob(arr[1])

    let n = bstr.length

    const u8arr = new Uint8Array(n)

    while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
    }

    return new File([u8arr], fileName, { type: mime })
}